import React, {useEffect, useState} from "react";
import {getPaymentLinkById} from "../../api";
import {SWIREPAY_URL} from "../../appconstants";
import ErrorPage from "../../components/error";

type Props = {}

const Expired = (props: Props) => {

    const [goBackUrl, setGoBackUrl] = useState(SWIREPAY_URL);

    const {match : { params : { paymentLinkId } }, location: { pathname }} = props;

    useEffect(() => {
        if(paymentLinkId) {
            getPaymentLinkById(paymentLinkId).then(value => {
                const { redirectUri } = value;
                setGoBackUrl(redirectUri || SWIREPAY_URL);
            }).catch(() => {
                props.history.push(`${pathname}/error`)
            });
        }
    }, [paymentLinkId, props.history, pathname]);

    return (
      <ErrorPage
        heading={'Expired Link'}
        body={'The link has expired. This means that your payment has already been processed or your session has expired.'}
        url={goBackUrl}
      />
    )
};

export default Expired;
